module.exports = __webpack_public_path__ + "static/media/warning.936aa94d.svg";